// extracted by mini-css-extract-plugin
export default {"HamburgerIcon":"HamburgerIcon_HamburgerIcon__uX2P4","Open":"HamburgerIcon_Open__Opb7S"};